import type { SearchLocation } from '~/modules/search/type/api';

export interface RegionOption {
    label: string;
    location: SearchLocation;
}

// Step 2 region options, keyed by country, so AU/US visitors don't see NZ
// regions. NZ uses the ES `region` field; AU/US specific places use `state`;
// US super-regions (Northeast/Midwest/South/West) use `region` since the API
// indexes those as region groupings.
const REGION_OPTIONS_NZ: RegionOption[] = [
    { label: 'Auckland', location: { region: 'Auckland' } },
    { label: 'Wellington', location: { region: 'Wellington' } },
    { label: 'Canterbury', location: { region: 'Canterbury' } },
    { label: 'Upper North Island', location: { region: 'Upper North Island' } },
    {
        label: 'Central North Island',
        location: { region: 'Central North Island' },
    },
    { label: 'Upper South Island', location: { region: 'Upper South Island' } },
    { label: 'West Coast', location: { region: 'West Coast' } },
    { label: 'Lower South Island', location: { region: 'Lower South Island' } },
    { label: 'Outside of New Zealand', location: { country: 'Outside NZ' } },
];

const REGION_OPTIONS_AU: RegionOption[] = [
    { label: 'New South Wales', location: { state: 'New South Wales' } },
    { label: 'Victoria', location: { state: 'Victoria' } },
    { label: 'Queensland', location: { state: 'Queensland' } },
    { label: 'Western Australia', location: { state: 'Western Australia' } },
    { label: 'South Australia', location: { state: 'South Australia' } },
    { label: 'Tasmania', location: { state: 'Tasmania' } },
    {
        label: 'Australian Capital Territory',
        location: { state: 'Australian Capital Territory' },
    },
    { label: 'Northern Territory', location: { state: 'Northern Territory' } },
];

const REGION_OPTIONS_US: RegionOption[] = [
    { label: 'Northeast', location: { region: 'Northeast' } },
    { label: 'Midwest', location: { region: 'Midwest' } },
    { label: 'South', location: { region: 'South' } },
    { label: 'West', location: { region: 'West' } },
    { label: 'California', location: { state: 'California' } },
    { label: 'New York', location: { state: 'New York' } },
    { label: 'Texas', location: { state: 'Texas' } },
    { label: 'Florida', location: { state: 'Florida' } },
];

export const REGION_OPTIONS_BY_COUNTRY: Record<string, RegionOption[]> = {
    NZ: REGION_OPTIONS_NZ,
    AU: REGION_OPTIONS_AU,
    US: REGION_OPTIONS_US,
};
